var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button } from 'rebass';
var Option = React.forwardRef(function (_a, ref) {
    var isSelected = _a.isSelected, isFocused = _a.isFocused, hideSelected = _a.hideSelected, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, props = __rest(_a, ["isSelected", "isFocused", "hideSelected", "variant"]);
    return (React.createElement(Button, __assign({ ref: ref, py: "14px", px: 4, bg: isSelected || isFocused ? 'neutral_1' : 'transparent', tabIndex: 0, variant: "option." + variant }, props, { sx: {
            border: 'none',
            borderRadius: 0,
            cursor: 'pointer',
            display: hideSelected && isSelected ? 'none' : null,
            fontSize: '13px',
            lineHeight: 'normal',
            outline: 0,
            textAlign: 'left',
            transition: 'all ease .2s',
            width: '100%',
        } })));
});
export default Option;
